import { render, staticRenderFns } from "./marketplace-details-card.component.vue?vue&type=template&id=53626189"
import script from "./marketplace-details-card.component.vue?vue&type=script&lang=js"
export * from "./marketplace-details-card.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports